import { z } from "zod";
import { documentCategorySchema } from "../../workflows/document-categories.js";
import { incidentContainerSchema } from "../../workflows/incident-containers.js";
export const linkedDocumentLinkSchema = z.object({
    container: incidentContainerSchema,
    sectionId: z.uuid().optional(),
});
export const linkedDocumentSchema = z.object({
    documentUrl: z.url(),
    category: documentCategorySchema,
    links: z.array(linkedDocumentLinkSchema).min(1),
});
/** Pre-multi-container snapshots. Read path only — normalised, never written back in this shape. */
const legacyLinkedDocumentSchema = z
    .object({
    documentUrl: z.url(),
    category: documentCategorySchema,
    container: incidentContainerSchema,
})
    .transform(({ documentUrl, category, container }) => ({ documentUrl, category, links: [{ container }] }))
    .pipe(linkedDocumentSchema);
/** Full accumulated snapshot of every linked document — not a per-batch delta. */
export const linkDocumentsResultSchema = z.array(z.union([linkedDocumentSchema, legacyLinkedDocumentSchema])).min(1);
